import { useSgdChfRate, sgdToChf } from "@/lib/currency";

/**
 * Renders an SGD amount as CHF using the live rate.
 *   <Chf sgd={5000000} />          -> CHF 3’230’000
 *   <Chf sgd={5000000} compact />  -> CHF 3.23M
 *   <Chf sgd={240000} approx />    -> ~CHF 155’040
 */
export default function Chf({ sgd, compact = false, approx = false, prefix = "" }) {
  const rate = useSgdChfRate();
  return (
    <>
      {approx ? "~" : ""}
      {prefix}
      {sgdToChf(sgd, rate, { compact })}
    </>
  );
}
